import { Check, ChevronDown, X } from 'react-feather';
import styles from '../rentalappplication.module.css';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from "@mui/material";
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import SignaturePad from "react-signature-canvas";

const schema = yup.object().shape({
    terms: yup.boolean().oneOf([true], 'Please accept Terms & Conditions and sign to proceed.'),
    signature: yup.string().when('terms', {
        is: true,
        then: yup.string().required('Signature is required.').nullable(),
        otherwise: yup.string().notRequired(),
    })
});

const TermsCondAccordion = ({ expanded, stepData, setStepData, accordinChange, lastStep, setPanelExpanded, panelRef, applicantId }) => {
    const [termsCheckedShow, setTermsCheckedShow] = useState(false);
    const [sigDialogOpen, setSigDialogOpen] = useState(false);
    const [signaureImage, setSignaureImage] = useState('');
    let sigCanvas = useRef({});

    const { register, handleSubmit, control, setValue, formState: { errors }, clearErrors } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
        defaultValues: {
            terms: false,
            signature: ''
        }
    });

    useEffect(() => {
        if (stepData) {
            if (stepData?.terms) {
                setValue('terms', true);
                setTermsCheckedShow(true);
            }
            if (stepData?.signature) {
                setValue('signature', stepData?.signature);
                setSignaureImage(stepData?.signature);
            }
        }
    }, [stepData, setValue]);

    const onSubmit = (data) => {
        setPanelExpanded(false);

        let postData = { is_term_submitted: 1, signature: data?.signature };
        setStepData(prev => {
            return { ...prev, ...postData };
        });

        if (applicantId) {
            axios.post(process.env.REACT_APP_APPLICANT_API_URL + 'v1/save-applicants/' + applicantId, postData);
        }
    }

    const formatIntoPng = () => {
        if (sigCanvas.current) {
            const dataURL = sigCanvas.current.toDataURL();
            setSignaureImage(dataURL);
            return dataURL;
        }
    }


    return (<Accordion expanded={expanded === 'panel9'} onChange={accordinChange('panel9', 9)} disabled={lastStep < 9}>
        <AccordionSummary expandIcon={<ChevronDown />} aria-controls="panel1bh-content" id="panel1bh-header" ref={panelRef}>
            <div className={`${styles.FormAccoHead}`}>
                <p className={`${styles.FormAccoHeadTitle}`}>Terms & Conditions</p>
                <div className={((lastStep > 9) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`)}><Check /></div>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${styles.AccoFormSec}`}>

                    <div className={`${styles.DivFull} ${styles.DivFullTerm}`}>
                        <p className={`${styles.TermText}`}>Please read carefully and click below to agree. Applicant certifies that the information contained in this application is true and correct. Applicant understands that false or misleading information is grounds for immediate disqualification. Applicant shall pay to the Landlord a nonrefundable fee to accompany this application to cover the Landlord’s administrative costs and expense to verify the information submitted by the Applicant.</p>
                        <p className={`${styles.TermTextTitle}`}>Authorization</p>
                        <p className={`${styles.TermText}`}>Applicant authorizes the Landlord or Landlord’s representatives to make any inquires deemed necessary to verify Applicant is the most qualified based on the below stated qualification standards. This verification includes, but is not limited to, direct contact with Applicant’s employers, current landlord, previous landlords, friends, personal and professional references, law enforcement agencies, government agencies, consumer reporting agencies, public records, eviction records, and any other sources of information which the Landlord or Landlord’s representative may deem necessary. Applicant verifies that the Landlord and Landlord’s representatives shall not be held liable for damages of any kind that result from the verification of the information provided. This authorization shall extend through Applicant’s tenancy to ensure continued compliance to the terms of tenancy or to recover any financial obligations relating to Applicant’s tenancy, and beyond the expiration of Applicant’s tenancy for recovery of any financial obligations, or for any other acceptable purpose. Should the Applicant be denied or face other adverse action based on information received in a consumer report, the Applicant has a right to obtain a free copy of the consumer report, and to dispute the accuracy of the information it contains by contacting the Consumer Reporting Agencies.</p>
                        <p className={`${styles.TermTextTitle}`}>Holding Fee</p>
                        <p className={`${styles.TermText}`}>Upon the verbal or written approval of the Applicant’s tenancy, if tenant will not be taking occupancy immediately, a Deposit to Hold Agreement will be executed and signed by all parties and a <strong>non-refundable</strong> holding fee shall be required within 24 hours, hereinafter referred to as “Deposit to Hold” in the amount equal to one month’s rent to hold the apartment until a mutually agreed upon move-in date. Applicant understands that no rental will be held for more than 14 days. The Deposit to Hold removes the property from public offering and holds the exclusively for the Applicant until all other requirements have been met. After all requirements have been met and a lease for the property completed, the Deposit to Hold will transfer to the security deposit to be held throughout the tenant’s entire tenancy. If the Applicant fails to provide the Deposit to Hold within 24 hours of approval, the Applicant may be disqualified and the apartment will be offered to the next qualified applicant. After approval and before occupancy will be granted, Applicant must supply all the required move-in funds, including the security deposit, first month’s rent, and any other additional deposits and fees, all tenant paid utilities must be transferred into Applicant’s name, and a lease must be executed and signed by all parties. If for any reason, the Applicant fails to complete all move-in requirements the landlord will return the property to public offering and the entire Deposit to Hold will be forfeited to the Landlord for expenses including, but not limited to, lost rent, holding costs, advertising costs, and marketing costs.</p>
                        <p className={`${styles.TermTextTitle}`}>Move-in Requirements</p>
                        <p className={`${styles.TermText}`}>After approval and before occupancy will be granted, Prospective Tenant must supply all the required move-in funds, including the security deposit, first month’s rent, and any other additional deposits and fees, all tenant paid utilities must be transferred into Prospective Tenant’s name, and a lease must be executed and signed by all parties.</p>
                        <p className={`${styles.TermText}`}><strong>Qualification Standards</strong> Your Application will be denied if you do not meet the below standards for qualification.</p>
                        <ul className={`${styles.TermText}`}>
                            <li>Applicant must have current photo identification and a valid social security number.</li>
                            <li>Applicant's monthly household income must exceed three times the rent. All income must be from a verifiable source. Unverifiable income will not be considered.</li>
                            <li>Applicants must receive positive references from all previous landlords for the previous 5 years.</li>
                            <li>Applicant may not have any evictions or unpaid judgments from previous landlords.</li>
                            <li>Applicant must exhibit a responsible financial life. Credit score must be a minimum of 600.</li>
                            <li>A background check will be conducted on all applicants over 18. Applicant’s background must exhibit a pattern of responsibility.</li>
                            <li>Applicant must be a non-smoker.</li>
                            <li>Occupancy is limited to 2 people per bedroom.</li>
                        </ul>
                        <p className={`${styles.TermText}`}>At landlord’s discretion, compensating factors such as an additional security deposit or co-signer (guarantor) may be required for qualification if Applicant fails to meet any one of the above requirements. In the event of multiple applicants, tenancy will be granted to the most qualified, based on the above criteria.</p>
                    </div>
                    <div className={`${styles.TermCheckBox} TermCheckBox`}>
                        <FormControlLabel className="AppliCheckBox"
                            control={<Controller
                                name="terms"
                                control={control}
                                render={(props) => <Checkbox
                                    {...props}
                                    onChange={(e) => {
                                        props.onChange(e);

                                        setValue('terms', e.target.checked);
                                        setTermsCheckedShow(e.target.checked);

                                        if (e.target.checked) {
                                            setSigDialogOpen(true);
                                        } else {
                                            setValue('signature', '');
                                            setSignaureImage('');
                                        }
                                    }}
                                    checked={props?.value ? true : false}
                                />}
                            />}
                            label="Applicant authorizes release of all information to Landlord and agrees that the information provided in this rental application is true and correct. This authorization extends beyond the end of Applicant’s tenancy."
                        />
                    </div>

                    {signaureImage !== '' && <div className={`${styles.UploadImgSign}`}>
                        <img src={signaureImage} alt="applicantImage" />
                    </div>}

                    <input type='hidden' {...register('signature')} />

                    {(errors.terms && !termsCheckedShow) && <p className={`${styles.ErrorM}`}>{errors.terms.message}</p>}
                    {(errors.signature) && <p className={`${styles.ErrorM}`}> {errors.signature.message}</p>}

                    <button type="submit" className={`${styles.SignButton}`}>Next</button>
                    {signaureImage !== '' && <button type="button" className={`${styles.SignedButton}`}>
                        <div className={`${styles.Icon}`}><Check /></div>
                        Application signed
                    </button>}



                </div>
            </form>

            <Dialog
                className="NewPopUp"
                fullwidth
                maxWidth="sm"
                open={sigDialogOpen}
                onClose={(e) => setSigDialogOpen(false)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    <span>Add your signature</span>
                    <button edge="start" color="inherit" onClick={(e) => setSigDialogOpen(false)} aria-label="close">
                        <X />
                    </button>
                </DialogTitle>
                <DialogContent className="SignaturePopupBody">
                    <SignaturePad
                        ref={sigCanvas}
                        onEnd={formatIntoPng}
                        penColor="black"
                        canvasProps={{
                            width: 550,
                            height: 250,

                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <button onClick={(e) => {
                        setValue('signature', ''); setSignaureImage(''); if (sigCanvas.current) { sigCanvas.current.clear(); }
                    }} color="primary" className="FileCanBU">Reset</button>
                    <button onClick={(e) => {
                        setSigDialogOpen(false);
                        setValue('signature', signaureImage);
                        setSigDialogOpen(false);
                        clearErrors();
                        if (sigCanvas.current) {
                            sigCanvas.current.clear();
                        }
                    }} color="primary" className="FileReBU">Insert</button>
                </DialogActions>
            </Dialog>
        </AccordionDetails>
    </Accordion >);
}

export default TermsCondAccordion;